export const getMesInformation = state => state.mesInformation;
export const getMesInformationBrand = state => state.mesInformation.brand;
export const getMesInformationClient = state => state.mesInformation.webClient;
export const getMesInformationSend = state => state.mesInformation.mesInformationSend;
export const getError = state => state.mesInformation.error;
export const getStatus = state => state.mesInformation.status;
export const getChangePass = state => state.mesInformation.changePass;